// extracted by mini-css-extract-plugin
export default {"hidden":"MsGh54","link":"fbb5Yy","active":"SGmO80","svg":"JqA4Gj","prev":"vUiBxm","link-active":"JLJkvU","linkActive":"JLJkvU"};